import { render, staticRenderFns } from "./ShopSelection.vue?vue&type=template&id=31ee3a64&"
import script from "./ShopSelection.vue?vue&type=script&lang=js&"
export * from "./ShopSelection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports